import { AnnotationTransientState } from '../../../cross-team-shared/annotation/shared/state/annotation-state';
import { ShapeState2D } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import {
  AbstractSensorContentState,
  ShapeFilter,
  ViewMode,
} from '../../../cross-team-shared/state/abstract-sensor-content-state';
import { LayerSettingsState2D } from '../../../cross-team-shared/state/layer-settings-state-2d';
import {
  SensorFrame2D,
  SensorRendererState,
} from '../../../cross-team-shared/state/sensor-renderer-state';
import { ObjectWith } from '../../../cross-team-shared/types/misc';
import { VectorLayerEditMode } from '../../../cross-team-shared/types/tool-modes';
import { ShapeGroupOrderState } from '../../../team-apis/content/content-connector';
import { ViewBox } from '../../../team-apis/content/view-box';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { AnnotationOutput2D } from '../../../team-apis/otterdam/outputs/annotation-output';
import { MouseState2D } from './mouse-state-2d';

interface VectorOverlayState extends ShapeGroupOrderState {
  shapeFeedbackMarkers: Point2D[];
}

export type Selection = ObjectWith<ObjectWith<true>>;

export class RasterOverlayState {
  rawMask?: Uint8Array;
  partialRawMask?: PartialRawMask;
}

export interface PartialRawMask {
  data: Uint8Array;
  xOffset: number;
  yOffset: number;
  width: number;
  height: number;
}

export abstract class AbstractSensorContentState2D extends AbstractSensorContentState {
  override output!: AnnotationOutput2D;
  frameNumber = 0;
  shapes!: ObjectWith<ShapeState2D>;
  trainingShapes: StrictRecord<number, ShapeState2D> = {};
  shapeTransientInfo: StrictRecord<number, AnnotationTransientState> = {};
  shapeFilters: ShapeFilter[] = [];
  selection: Selection = {};
  layerSettings!: LayerSettingsState2D;
  mouse = new MouseState2D();
  vectorOverlay: VectorOverlayState = {
    shapes: {},
    groups: {},
    shapeAndGroupOrder: [],
    shapeFeedbackMarkers: [],
  };
  viewMode: ViewMode = 'all';
  rasterOverlay?: RasterOverlayState;
  scale = 1; // description in mouse-coordinate.service.ts

  /**
   * Controls the viewBox attribute of the main SVG element. Controlled by the
   * image renderer and synced to all other renderers (on all content teams).
   */
  viewBox: ViewBox = [0, 0, 0, 0]; // default value until assets are loaded
  initialViewBox: ViewBox = [0, 0, 0, 0];
  zoomPanelViewBox: ViewBox = [0, 0, 0, 0];
  sensorRendererState!: SensorRendererState<SensorFrame2D>;
  editMode: VectorLayerEditMode = 'none';
  pixelSize = 1;
  isZoomPanelOpen = false;
  wasShapeCreationCancelled = false;
}
